import { Auth } from "@cleeng/mediastore-sdk";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import emailjs from '@emailjs/browser';
import { API_URL, REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, REACT_APP_PUBLIC_KEY } from "../../../constants";
import axios from "axios";
import { axiosConfig } from "../../../utils";
import { toast } from 'react-toastify';

function DataDeletionPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [removedId, setRemovedId] = useState("");

  useEffect(() => {
    if (!Auth.isLogged()) {
      localStorage.setItem('save_redirect_url', "/data-removal-request");
      navigate("/");
    }
  }, [navigate])

  const customerId = localStorage.getItem("CLEENG_CUSTOMER_ID");
  useEffect(() => {
    setRemovedId(localStorage.getItem("removal_requested") || "")
  }, [])

  const sendEmail = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${API_URL}/customers/${customerId}`,
        axiosConfig(),
      );
      const profile = data && data.responseData;
      if (profile) {
        emailjs.send(REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, {
          customerId: customerId,
          customerEmail: localStorage.getItem("CLEENG_CUSTOMER_EMAIL"),
          firstName: profile.firstName,
          lastName: profile.lastName
        }, REACT_APP_PUBLIC_KEY)
          .then(() => {
            toast('You have been successfully sent request');
            setRemovedId(customerId);
            localStorage.setItem("removal_requested", customerId);
          }, () => {
            toast('An error occurred');
          });
      }
    } catch (error) {
      toast('An error occurred');
    }
    finally {
      setLoading(false);
    }
  };
  return (
    <div className="data-deletion-container">
      <h1 className="data-deletion-header">Data Removal Request</h1>

      <p>The following information will be anonymized:</p>

      <ul>
        <li>Email</li>
        <li>Password</li>
        <li>First name</li>
        <li>Last name</li>
        <li>Address</li>
        <li>Company name</li>
        <li>Phone number</li>
        <li>Custom answers provided at registration</li>
        <li>IP addresses</li>
      </ul>
      <p></p>
      <p>The action cannot be reversed. Once your data has been removed, it cannot be retrieved.</p>
      <p>We will send a confirmation to your email address when we have completed your request.</p>
      <p></p>
      {customerId !== removedId &&
        <button className="btn msd__button msd__button--confirm btn-request-custom" disabled={loading} onClick={sendEmail}>Send Request</button>}
    </div>
  );
}

export default DataDeletionPage;
